// extracted by mini-css-extract-plugin
export default {"container":"CountrySelector_container__Z-bGU","label":"CountrySelector_label__-Ypxf","items":"CountrySelector_items__UcrpJ"};